export default __webpack_public_path__ + "static/media/brba.54120eaf.png";